<template>
  <v-container id="webshop-redirect">
    <v-row v-if="busy">
      <v-col class="text-center">
        <v-progress-circular
          :size="150"
          :width="6"
          class="mb-4"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div>{{ this.$t("message.payment_is_being_processed") }}</div>
      </v-col>
    </v-row>
    <v-row v-else justify="center">
      <v-col>
        <MaterialCard
          color="primary"
          elevation="1"
          class="tour-start"
          :title="getCardTitle"
        >
          <v-form>
            <v-container class="py-0">
              <v-row v-if="webshopResult.external_payment_state === 'paid'">
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="this.$t('label.name')"
                      disabled
                      :value="fullName"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="this.$t('label.email')"
                      disabled
                      :value="webshopResult.customer_email"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="this.$t('label.date')"
                      disabled
                      :value="webshopResult.created_at | datetime"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="this.$t('label.product')"
                      disabled
                      :value="webshopResult.product_name"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="this.$t('label.status')"
                      disabled
                      :value="
                        webshopResult.external_payment_state | payment_state
                      "
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="this.$t('label.amount')"
                      disabled
                      :value="(webshopResult.amount / 100) | currency"
                    />
                  </v-col>
                  <v-col
                    cols="4"
                    md="4"
                    v-if="webshopResult.customer_license_plate"
                  >
                    <v-text-field
                      :label="this.$t('label.license_plate')"
                      disabled
                      :value="webshopResult.customer_license_plate"
                    />
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="pa-1">
                    <h2>{{ $t("title.qr_code") }}:</h2>
                    <h5>{{ $t("info.qr_code_in_mailbox") }}</h5>
                  </v-col>
                  <v-col cols="4" class="text-center">
                    <canvas ref="canvas"></canvas>
                    <h3>
                      {{ webshopResult.delayed_delivery_identifier }}
                    </h3>
                    <v-btn
                      class="ma-3"
                      color="primary"
                      @click="downloadQRCode()"
                    >
                      {{ this.$t("button.download") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>
              <v-row v-else>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Datum"
                    disabled
                    :value="webshopResult.created_at | datetime"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Product"
                    disabled
                    :value="webshopResult.product_name"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Status"
                    disabled
                    :value="
                      webshopResult.external_payment_state | payment_state
                    "
                  />
                </v-col>
                <v-col cols="12" md="12">
                  <h3>{{ this.$t("message.navigate_to_online_purchases") }}</h3>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </MaterialCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCard from "../../../../../components/views/MaterialCard.vue";

export default {
  name: "WebshopRedirect",
  components: { MaterialCard },
  mounted() {
    if (!this.$store.state.webshop.payment_id) {
      this.webshopResult.external_payment_state === "failed";
    } else {
      setTimeout(() => {
        this.$store
          .dispatch("webshop/getPaymentResult")
          .then(response => {
            this.webshopResult = response.data;
            this.busy = false;
            let QRCode = require("qrcode");
            this.$nextTick(function() {
              let canvas = this.$refs.canvas;
              QRCode.toCanvas(
                canvas,
                this.webshopResult.delayed_delivery_identifier,
                { width: 250 },
                function() {}
              );
            });
          })
          .finally(() => {});
      }, 5000);
    }
  },
  data() {
    return {
      webshopResult: {},
      busy: true
    };
  },
  computed: {
    getCardIcon() {
      return this.webshopResult.external_payment_state === "paid"
        ? "mdi-check"
        : "mdi-alert-circle-outline";
    },
    getCardTitle() {
      return this.webshopResult.external_payment_state === "paid"
        ? "Uw bestelling is succesvol afgerond!"
        : "Uw bestelling is afgerond met een foutmelding.";
    },
    fullName() {
      if (this.webshopResult.customer_last_name !== null) {
        return (
          this.webshopResult.customer_first_name +
          " " +
          this.webshopResult.customer_last_name
        );
      }
      return this.webshopResult.customer_first_name;
    }
  },
  methods: {
    downloadQRCode() {
      let link = document.createElement("a");
      link.download = `${this.webshopResult.delayed_delivery_identifier}.png`;
      link.href = this.$refs.canvas.toDataURL();
      link.click();
    }
  }
};
</script>
